export default "__VITE_ASSET__C0K11sQC__"